import { useState } from "react";
import { useQuery, queryCache } from "react-query";
import { useAsync } from "@applied-med/ui/dist/hooks";
import { msalJwtToken, user } from "_shared/auth";
import ServiceNowAPI from "../ServiceNowAPI";

export const useApprovals = (config = {}) => {
  const queryFn = async () => {
    console.log("userID: ", user.TeamId);
    const response = await ServiceNowAPI.getApprovals({
      params: { approver: user.TeamId || "undefined" },
    })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        console.log(error);
        return "cannot access ServiceNow";
        // return error
      });
    if (response === "cannot access ServiceNow") {
      console.log("returning blank items. . .");
      return { items: [] };
    }

    const approvalsData = response.data;
    console.log({ approvalsData });
    const items = approvalsData.result;

    return {
      items,
    };
  };

  return useQuery("servicenow-approvals", queryFn, {
    staleTime: 1000 * 30,
    retry: 1,
    onError: (error) => {
      console.log("react query error: ", error);
    },
    retryOnMount: false,
    ...config,
  });
};

export const useMyRequests = (config = {}) => {
  const queryFn = async () => {
    const response = await ServiceNowAPI.getRequests({
      params: { requester: user.TeamId },
    })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        console.log(error);
        return "cannot access ServiceNow";
      });
    if (response === "cannot access ServiceNow") {
      console.log("returning blank items. . .");
      return { items: [] };
    }

    const requestsData = response.data;
    console.log({ requestsData });
    const items = requestsData.result;

    return {
      items,
    };
  };

  return useQuery("servicenow-my-requests", queryFn, {
    staleTime: 1000 * 30,
    retry: 1,
    onError: (error) => {
      console.log("react query error: ", error);
    },
    ...config,
  });
};

export const useRequestDetails = ({ args, ...config }) => {
  const queryFn = async () => {
    const response = await ServiceNowAPI.getApprovalDetails({
      params: { ritmSysId: args.params.ritmSysID, requester_id: user.TeamId },
    })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        console.log(error);
        return "cannot access ServiceNow";
      });
    if (response === "cannot access ServiceNow") {
      console.log("returning blank items and desktoplink. . .");
      return { items: [] };
    }

    const requestsData = response.data;
    console.log({ requestsData });
    const items = requestsData.result || [];

    return items;
  };

  return useQuery(["servicenow-request-details", args], queryFn, {
    staleTime: 1000 * 15,
    retry: 1,
    ...config,
  });
};

export const useServiceNowDetails = ({ args }) => {
  const [data, setData] = useState(() => {
    return queryCache.getQueryData(["servicenow-request-details", args]);
  });

  const requestDetailsQuery = useRequestDetails({
    args,
    enabled: true,
    onSuccess: (data) => {
      setData(data);
    },
  });
  const details = useAsync({
    queries: {
      requestDetailsQuery,
    },
  });
  console.log({ details, data });
  return { ...details, data };
};
